export const NAVIGATION = {
  main: [
    { label: 'About', path: '#about', hasDropdown: true },
    { label: 'What is Adaptive Golf?', path: '/what-is-adaptive-golf' },
    { label: 'Try Golf', path: '/try-golf' },
    { label: 'Competition', path: '/competition' },
    { label: 'Media', path: '/media' },
  ],
  about: [
    { label: 'About Us', path: '/about-us' },
    { label: 'AGAF Team', path: '/team' },
  ],
  right: [
    { label: 'Blog', path: '/blog' },
    { label: 'Get Involved', path: '/get-involved', isCta: true },
    { label: 'News', path: '/news' },
  ],
  footer: {
    contact: {
      text: 'Get in touch',
      email: 'contactus@adaptivegolfalliance.com',
      ctaLabel: 'Contact Us',
      ctaPath: '/connect',
    },
    newsletter: {
      text: 'Join our newsletter',
      signupLabel: 'Sign up',
    },
  },
};

export const ROUTES = {
  home: '/',
  whatIsAdaptiveGolf: '/what-is-adaptive-golf',
  tryGolf: '/try-golf',
  competition: '/competition',
  agaCalendar: '/competition/aga-calendar',
  media: '/media',
  playerStories: '/media/player-stories',
  playerStoryVishwa: '/media/player-stories/vishwa-vardhan-bhati',
  blog: '/blog',
  blogEmpowerment: '/blog/more-than-a-game',
  blogVolunteers: '/blog/power-of-volunteers',
  blogAdaptiveCoaching: '/blog/adaptive-coaching',
  blogBeyondVision: '/blog/beyond-vision',
  blogCzechDisabledGolfMasters: '/blog/czech-disabled-golf-masters-2026',
  blogCol: '/blog/PostCol',
  blogCol2: '/blog/PostCol2',
  getInvolved: '/get-involved',
  donate: '/donate',
  news: '/news',
  newsMilestone: '/news/a-milestone-moment',
  newsDiscoveryDay: '/news/where-sound-leads-the-game',
  newsAdaptiveOpen: '/news/india-adaptive-open-2026',
  newsCzechDisabledOpen: '/news/czech-disabled-golf-masters-2026',
  connect: '/connect',
  aboutUs: '/about-us',
  team: '/team',
}; 
